import vue from 'vue'
import {
  Button,
  Icon,
  Col,
  Row,
  Popup,
  Overlay,
  Form,
  Field,
  Loading,
  PullRefresh,
  Swipe,
  SwipeItem,
  Cell,
  CellGroup,
  Grid,
  GridItem,
  Card,
  Image as VanImage,
  ImagePreview,
  Lazyload,
  Toast
} from 'vant'

vue
  .use(Button)
  .use(Icon)
  .use(Col)
  .use(Row)
  .use(Popup)
  .use(Overlay)
  .use(Form)
  .use(Field)
  .use(Loading)
  .use(PullRefresh)
  .use(Swipe)
  .use(SwipeItem)
  .use(Cell)
  .use(CellGroup)
  .use(Grid)
  .use(GridItem)
  .use(Card)
  .use(VanImage)
  .use(ImagePreview)
  .use(Lazyload)
  .use(Toast)
